import { render, staticRenderFns } from "./CustomerSpecificPricesUpload.vue?vue&type=template&id=c1766e98"
import script from "./CustomerSpecificPricesUpload.vue?vue&type=script&lang=js"
export * from "./CustomerSpecificPricesUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports